// extracted by mini-css-extract-plugin
export default {"wrapper":"rNBd8lUASp5r_prxQALK"};